import { render, staticRenderFns } from "./ieError.vue?vue&type=template&id=5d0af2aa&scoped=true&"
import script from "./ieError.vue?vue&type=script&lang=js&"
export * from "./ieError.vue?vue&type=script&lang=js&"
import style0 from "./ieError.vue?vue&type=style&index=0&id=5d0af2aa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0af2aa",
  null
  
)

export default component.exports